 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		48: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		48: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~ActivationFlow~BuyFlow~CalculatorWidget~CaseManagementWidget~EshopLeasingDetailsView~HomeInt~83095350","1":"vendors~ActivationFlow~BuyFlow~CaseManagementWidget~FaqComponent~MessageWidgetFlow~OtpWidget~PricePl~a0e3dabe","2":"vendors~ActivationFlow~BuyFlow~CaseManagementWidget~FaqComponent~MessageWidgetFlow~OtpWidget~Product~3a563968","3":"vendors~ActivationFlow~BuyFlow~InstantPay~MessageWidgetFlow~OtpWidget~RedemptionFlow~SOGGiftCardDeta~3aa99e43","4":"CalculatorWidget~EshopLeasingDetailsView~HomeInternetFilter~InstantPay~MobileInternetFilter~ProductD~1499e4eb","5":"FaqComponent~PricePlanCards~ProductListingCategory~SubscriptionPage","10":"EshopLeasingDetailsView~ProductDetailsView","11":"MessageWidgetFlow","12":"vendors~FaqComponent~ProductListingCategory","13":"vendors~InstantPay~SpotifyBuyflowWidget","14":"ActivationFlow","15":"BuyFlow","16":"CalculatorWidget","17":"CaseManagementWidget","18":"EshopLeasingCatalogue","19":"EshopLeasingDetailsView","20":"FaqComponent","21":"GECheckUsageWidget","22":"GERoiForm","23":"HomeInternetFilter","24":"InstantPay","25":"MobileInternetFilter","26":"OtpWidget","27":"PickAndGoWidget","28":"PlanSelectionView","29":"PricePlanCards","30":"ProductCardCatalogue","31":"ProductDetailsView","32":"ProductListingCategory","33":"PromotionsWidget","34":"RedemptionFlow","35":"SAPDealsWidget","36":"SOGCardCatalogue","37":"SOGGiftCardDetails","38":"SOGRecommendations","39":"SpotifyBuyflowWidget","40":"StoreLocator","41":"SubscriptionFlow","42":"SubscriptionPage","43":"TradeInWidget","44":"TransactionResult","45":"VasMessageWidgetFlow","46":"WebSearchBar","49":"vendors~EshopLeasingCatalogue","50":"vendors~GECheckUsageWidget","51":"vendors~GERoiForm","52":"vendors~PickAndGoWidget","53":"vendors~PricePlanCards","54":"vendors~PromotionsWidget","55":"vendors~StoreLocator","56":"vendors~SubscriptionPage","57":"vendors~TradeInWidget","58":"vendors~WebSearchBar"}[chunkId]||chunkId) + "." + {"0":"93ecf14d","1":"2bcf16f6","2":"eac8a990","3":"16dfce71","4":"091d9899","5":"83648889","6":"f774d043","7":"a463f7a9","8":"d789afc9","9":"70e779f6","10":"241b3e72","11":"0670b0f0","12":"a37fd539","13":"6275f550","14":"5d4e7395","15":"9bbed00f","16":"5d21222a","17":"ada55810","18":"b997a304","19":"fdac520d","20":"cf741732","21":"99b2f4da","22":"f2ac1cd7","23":"417bdeb6","24":"05686b2a","25":"c0705918","26":"d1190f8e","27":"9f87aa6a","28":"f2c1cdfa","29":"50c3a257","30":"eeceaf15","31":"1e0e1563","32":"f904de97","33":"8df7a369","34":"3da2be3f","35":"7072cb9a","36":"41b2762b","37":"bd26796e","38":"0ab995b1","39":"ac1bf7a9","40":"7bd5c546","41":"d5a9c4a7","42":"ea4624c0","43":"93c05428","44":"b4492df5","45":"ee40630a","46":"ea86fbed","49":"6ec20b1b","50":"28f4fd4a","51":"7baa617f","52":"13818056","53":"a11a83cc","54":"0c7be0a2","55":"99b0aea2","56":"7fabe2f1","57":"87344d41","58":"f8f0f591","59":"c6dbd3c4","60":"f1309ef3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1,"37":1,"58":1,"59":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendors~ActivationFlow~BuyFlow~CalculatorWidget~CaseManagementWidget~EshopLeasingDetailsView~HomeInt~83095350","1":"vendors~ActivationFlow~BuyFlow~CaseManagementWidget~FaqComponent~MessageWidgetFlow~OtpWidget~PricePl~a0e3dabe","2":"vendors~ActivationFlow~BuyFlow~CaseManagementWidget~FaqComponent~MessageWidgetFlow~OtpWidget~Product~3a563968","3":"vendors~ActivationFlow~BuyFlow~InstantPay~MessageWidgetFlow~OtpWidget~RedemptionFlow~SOGGiftCardDeta~3aa99e43","4":"CalculatorWidget~EshopLeasingDetailsView~HomeInternetFilter~InstantPay~MobileInternetFilter~ProductD~1499e4eb","5":"FaqComponent~PricePlanCards~ProductListingCategory~SubscriptionPage","10":"EshopLeasingDetailsView~ProductDetailsView","11":"MessageWidgetFlow","12":"vendors~FaqComponent~ProductListingCategory","13":"vendors~InstantPay~SpotifyBuyflowWidget","14":"ActivationFlow","15":"BuyFlow","16":"CalculatorWidget","17":"CaseManagementWidget","18":"EshopLeasingCatalogue","19":"EshopLeasingDetailsView","20":"FaqComponent","21":"GECheckUsageWidget","22":"GERoiForm","23":"HomeInternetFilter","24":"InstantPay","25":"MobileInternetFilter","26":"OtpWidget","27":"PickAndGoWidget","28":"PlanSelectionView","29":"PricePlanCards","30":"ProductCardCatalogue","31":"ProductDetailsView","32":"ProductListingCategory","33":"PromotionsWidget","34":"RedemptionFlow","35":"SAPDealsWidget","36":"SOGCardCatalogue","37":"SOGGiftCardDetails","38":"SOGRecommendations","39":"SpotifyBuyflowWidget","40":"StoreLocator","41":"SubscriptionFlow","42":"SubscriptionPage","43":"TradeInWidget","44":"TransactionResult","45":"VasMessageWidgetFlow","46":"WebSearchBar","49":"vendors~EshopLeasingCatalogue","50":"vendors~GECheckUsageWidget","51":"vendors~GERoiForm","52":"vendors~PickAndGoWidget","53":"vendors~PricePlanCards","54":"vendors~PromotionsWidget","55":"vendors~StoreLocator","56":"vendors~SubscriptionPage","57":"vendors~TradeInWidget","58":"vendors~WebSearchBar"}[chunkId]||chunkId) + "." + {"0":"93ecf14d","1":"2bcf16f6","2":"eac8a990","3":"16dfce71","4":"091d9899","5":"83648889","6":"f774d043","7":"a463f7a9","8":"d789afc9","9":"70e779f6","10":"241b3e72","11":"0670b0f0","12":"a37fd539","13":"6275f550","14":"5d4e7395","15":"9bbed00f","16":"5d21222a","17":"ada55810","18":"b997a304","19":"fdac520d","20":"cf741732","21":"99b2f4da","22":"f2ac1cd7","23":"417bdeb6","24":"05686b2a","25":"c0705918","26":"d1190f8e","27":"9f87aa6a","28":"f2c1cdfa","29":"50c3a257","30":"eeceaf15","31":"1e0e1563","32":"f904de97","33":"8df7a369","34":"3da2be3f","35":"7072cb9a","36":"41b2762b","37":"bd26796e","38":"0ab995b1","39":"ac1bf7a9","40":"7bd5c546","41":"d5a9c4a7","42":"ea4624c0","43":"93c05428","44":"b4492df5","45":"ee40630a","46":"ea86fbed","49":"6ec20b1b","50":"28f4fd4a","51":"7baa617f","52":"13818056","53":"a11a83cc","54":"0c7be0a2","55":"99b0aea2","56":"7fabe2f1","57":"87344d41","58":"f8f0f591","59":"c6dbd3c4","60":"f1309ef3"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.aws.singtel.com/lux/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
